<template>
  <div class="m-wap-column">
    <span
      class="icontemp zuojiantou-"
      v-show="showArrow"
      @click="prevClick"
    ></span>
    <span
      class="icontemp youjiantou-"
      v-show="showArrow"
      @click="nextClick"
    ></span>
    <a-tabs
      default-active-key="1"
      @prevClick="prevClick"
      @nextClick="prevClick"
      @change="checkCategory"
      :animated="false"
      size="large"
    >
      <a-tab-pane
        v-for="item in categoryList"
        :key="item.articleCategoryId"
        :tab="item.title"
      >
      </a-tab-pane>
    </a-tabs>
  </div>

  <!--<div class="m-pc-column" :style="{'background':categoryBox.backgroundColor.value}" >-->

  <!--<div-->
  <!--class="column-item"-->
  <!--v-for="item in categoryList"-->
  <!--:key="item.articleCategoryId"-->
  <!--:class="{ active: item.isActive, '': item.isActive == 0 }"-->
  <!--@click="checkCategory(item)"-->
  <!--&gt;-->
  <!--<span :style="{'color':category.color.value}">{{ item.title }}</span>-->
  <!--</div>-->
  <!--</div>-->
</template>
<script>
import { articleCategoryId, globalUserId, isSetting } from "../../common/sbase";
import { columnData } from "../../common/settingData";
import service from "../../services/article";
import { $subscriber } from "fire-wind-water";
import $ from "jquery";
export default {
  name: "Column",
  data() {
    return {
      categoryList: [],
      title: "",
      showArrow: false,
      distance: 0
    };
  },
  created() {
    if (!isSetting) {
      this.getCategoryList();
    } else {
      this.categoryList = columnData;
      $subscriber.emit("get-actile-list", 1);
    }
  },
  methods: {
    getCategoryList() {
      let param = {
        articleCategoryId: articleCategoryId,
        globalUserId: globalUserId
      };
      service.getSubList(param).subscribe(data => {
        this.categoryList = data.content.subCategories;
        setTimeout(() => {
          this.showArrow =
            $(".ant-tabs-nav-scroll").width() < $(".ant-tabs-nav").width();
          this.distance = $(".ant-tabs-nav-scroll").width();
          console.log(
            $(".ant-tabs-nav-scroll").scrollLeft(),
            $(".ant-tabs-nav-scroll").width(),
            $(".ant-tabs-nav").width()
          );
        }, 0);
        $subscriber.emit("category-title", data.content.title); //获取到网页标题
        if (this.categoryList.length > 0) {
          this.categoryList[0].isActive = true;
          $subscriber.emit(
            "get-actile-list",
            this.categoryList[0].articleCategoryId
          );
        }
        $subscriber.emit("category-info", data.content);
      });
    },
    prevClick() {
      console.log($(".ant-tabs-nav-scroll").scrollLeft(), this.distance);
      $(".ant-tabs-nav-scroll").animate({
        scrollLeft: $(".ant-tabs-nav-scroll").scrollLeft() - this.distance
      });
    },
    nextClick() {
      console.log($(".ant-tabs-nav-scroll").scrollLeft());
      $(".ant-tabs-nav-scroll").animate({
        scrollLeft: $(".ant-tabs-nav-scroll").scrollLeft() + this.distance
      });
    },
    checkCategory(articleCategoryId) {
      setTimeout(() => {
        $(".ant-tabs-nav").css("transform", "translate3d(0px, 0px, 0px)");
      }, 0);

      $subscriber.emit("get-actile-list", articleCategoryId);
      this.$forceUpdate(); //有坑 需要强制更新
    }
  },
  mounted() {},
  components: {}
};
</script>
